// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1z96w","emails":"CreateEditClinics_emails__25YQV","emailTagLabel":"CreateEditClinics_emailTagLabel__1KYAq"};